import { render, staticRenderFns } from "./talent-level-label.component.vue?vue&type=template&id=11a0f818&scoped=true&"
import script from "./talent-level-label.component.vue?vue&type=script&lang=ts&"
export * from "./talent-level-label.component.vue?vue&type=script&lang=ts&"
import style0 from "./talent-level-label.component.vue?vue&type=style&index=0&id=11a0f818&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0f818",
  null
  
)

export default component.exports